import {Actions, Effect} from '@ngrx/effects';
import {Injectable} from '@angular/core';
import {Store} from '@ngrx/store';
import {Observable} from 'rxjs';

import {CampusService, ParticipationFormService, PersonService} from '../service';
import {ACTION} from '../constant';

@Injectable()
export class Effects {
  @Effect() loadParticipationForms$ = this.actions$
    .ofType(ACTION.LOAD_PARTICIPATION_FORMS)
    .switchMap(() =>
      this.participationFormService.getParticipationForms()
        .then(res => ({type: ACTION.LOAD_PARTICIPATION_FORMS_COMPLETED, payload: res})));
  @Effect() loadParticipationFormDraft$ = this.actions$
    .ofType(ACTION.PARTICIPATION_FORM_LOAD_DRAFT)
    .switchMap(() =>
      this.participationFormService.getParticipationFormDraft()
        .then(res => ({type: ACTION.PARTICIPATION_FORM_LOAD_DRAFT_COMPLETED, payload: res})));
  @Effect() loadFormBySubCode$ = this.actions$
    .ofType(ACTION.PARTICIPATION_FORM_LOAD)
    .switchMap(state => this.participationFormService.getBySubmissionCode(state.payload.formSubmissionCode)
      .then(participationForm => ({
        type: ACTION.PARTICIPATION_FORM_LOAD_COMPLETED,
        payload: participationForm
      }))
      .catch(err => {
        this.store.dispatch({type: ACTION.ERROR, payload: err});
        return Observable.of({type: ACTION.ERROR, payload: err});
      }));
  @Effect() loadFormCleanupBySubCode$ = this.actions$
    .ofType(ACTION.PARTICIPATION_FORM_LOAD_CLEANUP)
    .switchMap(state => this.participationFormService
      .getBySubmissionCodeCleanup(state.payload.formSubmissionCode, state.payload.cleanupInProgress)
      .then(participationForm => ({
        type: ACTION.PARTICIPATION_FORM_LOAD_CLEANUP_COMPLETED,
        payload: participationForm
      }))
      .catch(err => {
        this.store.dispatch({type: ACTION.ERROR, payload: err});
        return Observable.of({type: ACTION.ERROR, payload: err});
      }));
  @Effect() saveParticipationForm$ = this.actions$
    .ofType(ACTION.PARTICIPATION_FORM_SAVE)
    .switchMap(() => this.store.select<any>('PARTICIPATION_FORM_REDUCER').first()
      .switchMap(state => this.participationFormService.upsert(state.data.formSubmissionCode)
        .then(participationForm => ({
          type: ACTION.PARTICIPATION_FORM_SAVE_COMPLETED,
          payload: participationForm
        }))
        .catch(err => {
          this.store.dispatch({type: ACTION.ERROR, payload: err});
          return Observable.of({type: ACTION.ERROR, payload: err});
        })));
  @Effect() saveParticipationFormCleanup$ = this.actions$
    .ofType(ACTION.PARTICIPATION_FORM_SAVE_CLEANUP)
    .switchMap(() => this.store.select<any>('PARTICIPATION_FORM_REDUCER').first()
      .switchMap(state => this.participationFormService.upsertCleanup(state.data.formSubmissionCode)
        .then(participationForm => ({
          type: ACTION.PARTICIPATION_FORM_SAVE_CLEANUP_COMPLETED,
          payload: participationForm
        }))
        .catch(err => {
          this.store.dispatch({type: ACTION.ERROR, payload: err});
          return Observable.of({type: ACTION.ERROR, payload: err});
        })));
  @Effect() approveParticipationForm$ = this.actions$
    .ofType(ACTION.PARTICIPATION_FORM_APPROVE)
    .switchMap(() =>
      this.store.select<any>('PARTICIPATION_FORM_REDUCER').first()
        .switchMap(state =>
          this.participationFormService.approve(state.data.formSubmissionCode, state.data.workFlows[0].comment)
            .then(res => ({
              type: ACTION.PARTICIPATION_FORM_APPROVE_COMPLETED,
              payload: res
            }))
        )
    );
  @Effect() declineParticipationForm$ = this.actions$
    .ofType(ACTION.PARTICIPATION_FORM_DECLINE)
    .switchMap(() =>
      this.store.select<any>('PARTICIPATION_FORM_REDUCER').first()
        .switchMap(state =>
          this.participationFormService.decline(state.data.formSubmissionCode, state.data.workFlows[0].comment)
            .then(res => ({
              type: ACTION.PARTICIPATION_FORM_DECLINE_COMPLETED,
              payload: res
            })))
    );
  @Effect() returnParticipationForm$ = this.actions$
    .ofType(ACTION.PARTICIPATION_FORM_RETURN)
    .switchMap(() =>
      this.store.select<any>('PARTICIPATION_FORM_REDUCER').first()
        .switchMap(state =>
          this.participationFormService.returnApplication(state.data.formSubmissionCode, state.data.comments)
            .then(res => ({
              type: ACTION.PARTICIPATION_FORM_RETURN_COMPLETED,
              payload: res
            }))
        )
    );
  @Effect() amendParticipationForm$ = this.actions$
    .ofType(ACTION.PARTICIPATION_FORM_AMEND)
    .switchMap(() =>
      this.store.select<any>('PARTICIPATION_FORM_REDUCER').first()
        .switchMap(state => this.participationFormService
          .amendApplication(state.data.previousSubmissionCode, state.data.nextSubmissionCode, state.data.amendWithWF)
          .then(res => ({
            type: ACTION.PARTICIPATION_FORM_AMEND_COMPLETED,
            payload: res
          }))
        )
    );
  @Effect() emailSupplier$ = this.actions$
    .ofType(ACTION.PARTICIPATION_FORM_EMAIL_SUPPLIER)
    .switchMap(() =>
      this.store.select<any>('PARTICIPATION_FORM_REDUCER').first()
        .switchMap(state =>
          this.participationFormService.emailSupplier(state.data.formSubmissionCode)
            .then(res => ({
              type: ACTION.PARTICIPATION_FORM_EMAIL_SUPPLIER_COMPLETED,
              payload: res
            })))
    );
  @Effect() saveProgramName$ = this.actions$
    .ofType(ACTION.PARTICIPATION_FORM_SAVE_PROGRAM)
    .switchMap(() =>
      this.store.select<any>('PARTICIPATION_FORM_REDUCER').first()
        .switchMap(state =>
          this.participationFormService.saveProgramName(state.data.formSubmissionCode, state.data.programLocation, state.data.programNumber)
            .then(res => ({
              type: ACTION.PARTICIPATION_FORM_SAVE_PROGRAM_COMPLETED,
              payload: res
            }))
            .catch(err => {
              this.store.dispatch({type: ACTION.ERROR, payload: err});
              return Observable.of({type: ACTION.ERROR, payload: err});
            })));
  @Effect() restrictedSiteAccessApproval$ = this.actions$
    .ofType(ACTION.PARTICIPATION_FORM_RESTRICTED_SITE_APPROVAL)
    .switchMap(() =>
      this.store.select<any>('PARTICIPATION_FORM_REDUCER').first()
        .switchMap(state =>
          this.participationFormService.updateRestrictedSiteAccess(state.data.formSubmissionCode, true)
            .then(res => ({
              type: ACTION.PARTICIPATION_FORM_RESTRICTED_SITE_APPROVAL_COMPLETED,
              payload: res
            }))
            .catch(err => {
              this.store.dispatch({type: ACTION.ERROR, payload: err});
              return Observable.of({type: ACTION.ERROR, payload: err});
            })));
  @Effect() restrictedIndividualSiteAccessApproval$ = this.actions$
    .ofType(ACTION.PARTICIPATION_FORM_INDIVIDUAL_RESTRICTED_SITE_APPROVAL)
    .switchMap(() =>
      this.store.select<any>('PARTICIPATION_FORM_REDUCER').first()
        .switchMap(state =>
          this.participationFormService.updateIndividualRestrictedSiteAccess(state.data.formSubmissionCode, true)
            .then(res => ({
              type: ACTION.PARTICIPATION_FORM_INDIVIDUAL_RESTRICTED_SITE_APPROVAL_COMPLETED,
              payload: res
            }))
            .catch(err => {
              this.store.dispatch({type: ACTION.ERROR, payload: err});
              return Observable.of({type: ACTION.ERROR, payload: err});
            })));
  @Effect() generateProgramName$ = this.actions$
    .ofType(ACTION.PARTICIPATION_FORM_GENERATE_PROGRAM)
    .switchMap(() =>
      this.store.select<any>('PARTICIPATION_FORM_REDUCER').first()
        .switchMap(state =>
          this.participationFormService.generateProgramName(state.data.formSubmissionCode)
            .then(res => ({
              type: ACTION.PARTICIPATION_FORM_GENERATE_PROGRAM_COMPLETED,
              payload: res
            }))
            .catch(err => {
              this.store.dispatch({type: ACTION.ERROR, payload: err});
              return Observable.of({type: ACTION.ERROR, payload: err});
            })));
  @Effect() enableOrdering$ = this.actions$
    .ofType(ACTION.PARTICIPATION_FORM_ENABLE_ORDERING)
    .switchMap(() =>
      this.store.select<any>('PARTICIPATION_FORM_REDUCER').first()
        .switchMap(state =>
          this.participationFormService.enableOrdering(state.data.formSubmissionCode)
            .then(res => ({
              type: ACTION.PARTICIPATION_FORM_ENABLE_ORDERING_COMPLETED,
              payload: res
            })))
    );
  @Effect() inactivatedParticipationForm$ = this.actions$
    .ofType(ACTION.PARTICIPATION_FORM_INACTIVATE)
    .switchMap(() =>
      this.store.select<any>('PARTICIPATION_FORM_REDUCER').first()
        .switchMap(state =>
          this.participationFormService.inactivateParticipationForm(state.data.formSubmissionCode)
            .then(res => ({
              type: ACTION.PARTICIPATION_FORM_INACTIVATE_COMPLETED,
              payload: res
            }))
            .then(tes => ({
              type: ACTION.LOAD_PARTICIPATION_FORMS,
              payload: {}
            }))
            .catch(err => {
              this.store.dispatch({type: ACTION.ERROR, payload: err});
              return Observable.of({type: ACTION.ERROR, payload: err});
            })));
  @Effect() loadCurrentUser$ = this.actions$
    .ofType(ACTION.LOAD_CURRENT_USER)
    .switchMap(() =>
      this.personService.getCurrentUser()
        .then(res => ({type: ACTION.LOAD_CURRENT_USER_COMPLETED, payload: res}))
        .catch(err => {
          this.store.dispatch({type: ACTION.ERROR, payload: err});
          return Observable.of({type: ACTION.ERROR, payload: err});
        })
    );
  @Effect() fetchFormCode$ = this.actions$
    .ofType(ACTION.LOAD_FORM_CODE)
    .switchMap(() =>
      this.campusService.fetchFormCode()
        .then(res => ({type: ACTION.LOAD_FORM_CODE_COMPLETED, payload: res}))
        .catch(err => {
          this.store.dispatch({type: ACTION.ERROR, payload: err});
          return Observable.of({type: ACTION.ERROR, payload: err});
        }));

  constructor(private actions$: Actions,
              private participationFormService: ParticipationFormService,
              private personService: PersonService,
              private campusService: CampusService,
              private store: Store<any>) {
  }
}



// WEBPACK FOOTER //
// /home/runner/work/slipresistant/slipresistant/client/src/app/shared/effects/effects.ts